import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import Header from "@components/shared/header";
import colors from "@styles/variables/copiercostsVariables.module.scss";
import CopierCostsLogo from "@components/copiercosts/logo";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import Footer from "@components/shared/footer";
export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <>
            <Header
                slogan="Top Digital Copier Companies"
                textColor={colors.offerCallNumber}
                backGroundColor="transparent"
            >
                <CopierCostsLogo />
            </Header>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#094e92" />
                </div>
                <FormSection iconsFillColor="#094e92" />
            </div>
            <Footer />
        </>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
